import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Artists from "@/components/Artists";
import Creators from "@/components/Creators";
import Producers from "@/components/Producers";
import Release from "@/components/Release";
import Studios from "@/components/Studios";
import FounderTeaser from "@/components/FounderTeaser";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Impressum from "@/pages/Impressum";
import CreatorImpressum from "@/pages/CreatorImpressum";
import PersonPage from "@/pages/PersonPage";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import StudioPage from "@/pages/StudioPage";
import GeschichtePage from "@/pages/GeschichtePage";
import DriveApp from "@/drive/DriveApp";
import SignPage from "@/drive/pages/SignPage";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";

const Landing = () => {
  return (
    <main className="relative bg-[#050505] text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Artists />
      <Creators />
      <Producers />
      <Release />
      <Studios />
      <FounderTeaser />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#fff",
          },
        }}
      />
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <ContentProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/studio" element={<StudioPage />} />
              <Route path="/geschichte" element={<GeschichtePage />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/creator/:slug/impressum" element={<CreatorImpressum />} />
              <Route path="/kuenstler/:slug" element={<PersonPage type="artist" />} />
              <Route path="/creator/:slug" element={<PersonPage type="creator" />} />
              <Route path="/produzent/:slug" element={<PersonPage type="producer" />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<AGB />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/drive/*" element={<DriveApp />} />
              <Route path="/sign/:token" element={<SignPage />} />
            </Routes>
            <CookieBanner />
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
